import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

if (window.location.href=='https://chonkyfiregames.com/' || window.location.href=='https://www.chonkyfiregames.com/'){
    window.location.assign('https://forms.gle/1gYo86w89Wbm2oT87');
} else {
    ReactDOM.render(<App />, document.getElementById('root'));
}